module.exports = __webpack_public_path__ + "img/upcoming-events_wrestlemania.a6ccc105.jpg";